import { Environment } from '@instaclause-webapp/shared-core';

export const environment: Omit<Environment, 'accountantBaseUrl'> = {
  production: false,
  appName: 'accountant',
  apiBaseUrl: '/api',
  apiAuthUrl: 'https://admin.staging.instaclause.com/api',
  docsBaseUrl: 'https://documents.staging.instaclause.com',
  integrationsBaseUrl: 'https://integrations.staging.instaclause.com',
  version: '2.0.0-beta.18-rc.1',
  amplitudeApiKey: '3322e7baf2380ae53ff8892d0853b286',
  googleSignInClientId: '1016885070607-l1opuebubanqmh8sn88memm6hvlktueq.apps.googleusercontent.com',
  entraClientId: '5883619e-8dea-4d24-8e7f-d7d88acecf13',
  faroUrl: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/712c9418ab7f78df6e9edf167e453b99',
  docusignClientId: '909fdc74-f12b-41f5-996f-aba0d2757a97',
  docusignAuthServer: 'account-d.docusign.com',
  exactClientId: 'a4a53554-125d-4707-986e-656aa756bb60',
  exactRegion: 'nl',
  adminPulseClientId: 'instaclause2.0.client',
  hubSpotClientId: '4ca54f35-3f83-4210-81a6-90a47cfc7dc1',
};
